<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Book.header') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div v-if="booksLoaded == false" class="h-100 d-flex justify-content-center align-items-center">
            <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
          </div>

          <div v-else class="card card-form">
            <div class="card-body">
              <div class="form-section-header">{{ $t('message.Book.header') }}</div>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.title') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.title }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.displayed') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ $t('message.Book.displayedTimes', {times: book.displayed}) }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.slug') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.slug }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.edition') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.edition }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1" v-if="book.previous_edition && book.previous_edition.id > 0">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.previousEdition') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">
                    <a href="#" class="badge badge-info mr-2" @click.prevent="$router.push({name: 'BookView', params: {id: book.previous_edition.id}})">{{ book.previous_edition.title }}</a>
                  </label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.author') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">
                    <a class="badge badge-success mr-2" @click.prevent="$router.push({name: 'AuthorView', params: {id: author.id}})" href="#" v-for="(author, index) in book.authors" :key="author.id">{{ author.name }}</a>
                  </label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.category') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">
                    <a class="badge badge-success mr-2" @click.prevent="$router.push({name: 'CategoryView', params: {id: category.id}})" href="#" v-for="(category, index) in book.categories" :key="index">{{ category.name }}</a>
                  </label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.isbn') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.isbn }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.pageCount') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.page_count }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.price') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.price }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.publicationDate') }}</label>
                </b-col>

                <b-col sm="9">
                 <label class="col-form-label">{{ $moment(book.publication_date).format('YYYY-MM-DD') }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.type') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.type }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.format') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.format }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.language') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.language }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.publisher') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.publisher && book.publisher.name ? book.publisher.name : '' }}</label>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.shopLinks') }}</label>
                </b-col>

                <b-col sm="9">
                  <label class="col-form-label">{{ book.shop_links }}</label>
                </b-col>
              </b-row>
              
              <b-row class="my-1">
                <b-col sm="3">
                  <label class="col-form-label">{{ $t('message.Book.shopLinks') }}</label>
                </b-col>

                <b-col sm="9">
                  <div v-for="(link,index) in book.web_shoplinks" :key="index">
                    <p>
                      LABEL:<br> {{ link.label }} <br>
                      URL:<br> {{ link.link }}
                    </p>
                    <hr>
                  </div>
                </b-col>
              </b-row>

              <div class="form-section-header">Rezension</div>

              <div v-html="book.recension"></div>

              <template v-if="bookFiles && bookFiles.length > 0">
                <div class="form-section-header">{{ $t('message.Book.images') }}</div>

                <b-container fluid class="p-4">
                  <b-row class="mb-1">
                    <b-col v-for="(file, index) in bookFiles" :key="index">
                      <b-img thumbnail fluid :src="file.url" :alt="file.name" />
                    </b-col>
                  </b-row>
                </b-container>
              </template>

              <div class="form-buttons">
                <button type="submit" class="btn btn-primary mr-2" @click="$router.push({name: 'BookEdit', params: {id : book.id} })">{{ $t('message.edit') }} </button>
                <button type="submit" class="btn btn-success" @click="$router.go(-1)">{{ $t('message.return') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import { BOOKS_REQUEST_BY_ID } from '@/store/actions/books';

  import FileUpload from 'vue-upload-component'

  export default {
    name: "BookView",

    components: {
      Multiselect,
      FileUpload
    },

    data() {
      return {
        book: {
          authors: null,
          title: null,
          edition: null,
          previous_edition: null,
          recension: '',
          isbn: null,
          img: null,
          slug: null,
          page_count: null,
          price: null,
          rating: null,
          publication_date: null,
          type: null,
          format: null,
          language: null,
          publisher: null,
          shop_links: null,
          files: [],
          files_new: []
        },

        uploadedFiles: []
      }
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Book.errors.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.book.id == undefined) {
              return this.saveBook();
            }

            return this.updateBook();
          }
        });
      },


      getBook(id) {
        if (id != undefined) {
          this.$store.dispatch(BOOKS_REQUEST_BY_ID, id).then(book => {
            this.book = book;
          }).catch(err => {
            console.log(err)
          })
        }
      },
    },

    computed: {
      bookFiles() {
        return this.book.files
      }
    },

    mounted() {
      this.getBook(this.$route.params.id);
    },

    watch: {
      uploadedFiles: function (newValue) {
        let files = newValue.map( elem => {
          if ( elem.response.data && elem.response.data.id != undefined) {
            return {
              id: elem.response.data.id,
              url: elem.response.data.url,
              name: elem.name,
            }
          }
        })

        this.book.files_new = files;
      },
      '$route.params.id': function (bookId) {
        this.getBook(bookId);
      }
    },

  }
</script>

<style scoped>
.dragActive{
  background: white;
}

.dropzone {
  background: #e6e6e6;
  text-align: center;
  padding: 30px;
  border: 2px dashed;

  div {
    padding: 20px;
  }
}

.col-form-label {
  text-align: left;
}

.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4{
    input[type="file"] {
    opacity: 0;
    font-size: 20em;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.file-uploads.file-uploads-html5{
  input[type="file"] {
    overflow: hidden;
    position: fixed;
    width: 1px;
    height: 1px;
    z-index: -1;
    opacity: 0;
  }
}

.img-thumbnail{
  max-width: 300px;
}
</style>